import { useEffect, useState } from "react";
import api from "@/lib/api";

const POLL_MS = 20000;

// Lifted out of DocumentsPanel so the pending-submission count is available for
// the Documents tab badge (AdminDashboardPage) without a second fetch. Polls like
// the other admin alert hooks so submissions from other staff show up without a
// manual refresh; approve/reject actions inside DocumentsPanel update this same
// state directly via setDocuments, so the badge reflects them immediately.
export function useDocuments(user) {
  const [documents, setDocuments] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(true);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get("/admin/documents");
        if (cancelled) return;
        setDocuments(data.items || []);
      } catch {
        // silent — avoid spamming errors from background polling
      } finally {
        if (!cancelled) setLoadingDocs(false);
      }
    };

    poll();
    const interval = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user]);

  return { documents, setDocuments, loadingDocs };
}
